import React, { useState, useRef, useEffect } from "react";
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";

import "./App.css";
import theke from "./img/theke.jpeg";
import empayLogo from "./img/empayLogo.jpg";
import dinkel from "./img/dinkel.jpg";
import empanadasLogo from "./img/empanadasLogo.png";
import placeholder1 from "./img/placeholder1.jpg";
import placeholder2 from "./img/placeholder2.jpg";
const api = new WooCommerceRestApi({
  url: "https://empanadasytamales.de/",
  consumerKey: "ck_232b63803f556e76e420b743a5cb639675ab725f",
  consumerSecret: "cs_e063d5df0a523e27b68f841f0bbc8877b1f824ac",
  version: "wc/v3"
});
const App = () => {
  const [orders, setOrders] = useState([]);

  

  let fetchOrders = () => {
    api
      .get("orders", {
        per_page: 20,
      })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data, "ddd");
          setOrders(response.data);
        }
      })
      .catch((error) => {});
  };

  useEffect(() => {
    fetchOrders();
  }, []);

  const productIds = {
  arepasMais: 710,       
  arepasDinkel: 726,
  empanadas: 709,
  tamalesGrandes: 707,
  tamalesChiki: 708
};
const redirectToCheckout = async () => {
  // Empty the cart
  await fetch("https://empanadasytamales.de/?empty-cart=true", {
    credentials: 'include'
  });

  // Add products to cart
 for (const [key, quantity] of Object.entries(cart)) {
    if (quantity > 0) {
      const id = productIds[key];
      await fetch(`?add-to-cart=${id}&quantity=${quantity}`, {
        credentials: 'include'
      });
    }
  }

  // Trigger WooCommerce cart fragment refresh (vanilla JS)
  const event = new CustomEvent('wc_fragment_refresh');
  document.body.dispatchEvent(event);

  // Redirect to checkout
  window.location.href = 'https://empanadasytamales.de/finalizar-compra/';
};


  
  const carouselRef = useRef(null);
  const [cart, setCart] = useState({
    arepasMais: 0,
    arepasDinkel: 0,
    empanadas: 0,
    tamalesGrandes: 0,
    tamalesChiki: 0
  });
  const [images] = useState([theke, empayLogo, dinkel]);

  const incrementOrder = (meal) => {
    setCart(prevCart => {
      const newCart = { ...prevCart };
      if (newCart[meal] < 60) {
        newCart[meal] += 1;
        return newCart;
      }
      return prevCart;
    });
  };

  const decrementOrder = (meal) => {
    setCart(prevCart => {
      const newCart = { ...prevCart };
      if (newCart[meal] > 0) {
        newCart[meal] -= 1;
        return newCart;
      }
      return prevCart;
    });
  };


  return (
    <div className="container mt-5" id="locatethis">
      <div className="sticky-top nav-bg container-fluid">
        <div className="nav-container container-fluid">
          <nav className="navbar navbar-expand-sm navbar-light bg-light">
            <div className="container-fluid">
              <a className="navbar-brand" >
                <img
                  src={empanadasLogo}
                  alt="Empanadas y Tamales Logo"
                  width="50"
                  height="auto"
                  className="me-2"
                />
                <small>Empanadas y Tamales</small>
              
  
              {/* TOGGLER BUTTON */}
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarNav"
                aria-controls="navbarNav"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
              </a>
              {/* COLLAPSIBLE MENU */}
              <div className="collapse navbar-collapse" id="navbarNav">
                <ul className="navbar-nav ms-auto mb-2 mb-sm-0">
                  <li className="nav-item">
                    <a className="nav-link active" href="#home">Home</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#recetas">Zutaten</a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#uns">Über uns</a>
                  </li>
  
                  <li className="nav-item dropdown">
                            <a className="nav-link dropdown-toggle" href="#" id="lieferDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Lieferservice</a>
                            <ul className="dropdown-menu" aria-labelledby="lieferDropdown">
                              <li ><a className="dropdown-item" href="#menu" >Menü</a></li>
                              <li ><a className="dropdown-item" href="#menu" >Preisen</a></li>
                              <li ><a className="dropdown-item" href="#kontakt" >Kontakt</a></li>
                            </ul>
                          </li>
                          <li className="nav-item dropdown" >
                            <a className="nav-link dropdown-toggle" href="#" id="partnerDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">Partners</a>
                            <ul className="dropdown-menu" aria-labelledby="partnerDropdown" >
                              <li ><a className="dropdown-item" href="#fronteraLatina" >Frontera Latina</a></li>
                              <li ><a className="dropdown-item" href="#bioVegano" >Bio Vegano</a></li>
                              <li ><a className="dropdown-item" href="#lunasol">Galeria Lunasol</a></li>
                            </ul>
                          </li>
                        </ul>
                      </div>
                    </div>

          </nav>
        </div>
      </div>
              <div className="container mt-5">
              <div className="container-fluid" id="top-page">
              <header className="text-center">
            <div className="bg">
            <img src={empanadasLogo} className="rounded float-left" alt="logo" width="30%" />      
          <div className="mask mask-custom"></div>
          </div>
          </header>
          </div>

<div id="intro" className="container-fluid">
<div className="jumbotron">
  
<h2 className="display-2 text-center" id="home">Empanadas y Tamales</h2>    
          <p className="lead text-center">Produktion und Lieferservice von hausgemachten Empanadas, Tamales, und Arepas in Gourmet-Bio-Qualität. </p>
          <hr className="my-4"/>
          <p className="lead">Producción y servicio de entrega de empanadas caseras empanadas, tamales y arepas  en calidad gourmet orgánica.</p>
          <a className="btn btn-primary btn-lg" href="#menu" role="button">Menü</a>
          </div>        
          </div>
       <div className="container-fluid" id="page-section">
       
        {/* Title */}
        <h3 className="text-center display-3">Empanadas y Tamales Berlín<small className="text-muted"> – Lieferservice </small></h3>

        {/* Bootstrap Carousel */}
        <div className="d-flex justify-content-center">
  <div
    id="carouselExampleControls"
    className="carousel slide"
    data-bs-ride="carousel"
    style={{ width: "100%", height: "auto" }}
  >
    <div className="carousel-inner">
  {images.map((image, index) => (
    <div
      className={`carousel-item ${index === 0 ? "active" : ""}`}
      key={index}
      onClick={() => console.log("Background set to:", image)}
    >
      <img
        src={image}
        className="d-block w-100 img-fluid"
        alt={`Slide ${index}`}
      />
    </div>
  ))}
</div>

    <button
      className="carousel-control-prev"
      type="button"
      data-bs-target="#carouselExampleControls"
      data-bs-slide="prev"
    >
      <span className="carousel-control-prev-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Previous</span>
    </button>
    <button
      className="carousel-control-next"
      type="button"
      data-bs-target="#carouselExampleControls"
      data-bs-slide="next"
    >
      <span className="carousel-control-next-icon" aria-hidden="true"></span>
      <span className="visually-hidden">Next</span>
    </button>
  </div>
</div>

        <div data-spy="scroll" data-target="#navbar" data-offset="0">
        <div className="item">
          <div className="inner">
            </div>
            </div>

            
        <h4 id="uns">Über Uns</h4>
        <br/>
  <p className="lead"><span id="welcome">Herzlich willkommen,</span><br/>

seit über 20 Jahren produzieren wir lateinamerikanische Köstlichkeiten, wie Empanadas, Arepas, Tamales, Schinkenbrote, Desserts und Kuchen. Wir bitten Ihnen individuelle und unvergessliche Catering-Arrangement in Gourmet-Bio-Qualität. Verschiedene lateinamerikanische Botschaften greifen immer wieder auf unseren Service zurück.
<br/>
Seit Dezember 2023 beliefern wir nun auch private Haushalte ab einem Bestellwert von 50 EURO zzgl. einer Fahrtkostenpauschale von 8 EURO. Die Lieferung an drei Tagen in der Woche (dienstags, freitags und samstags).
<br/>
<br/>
<span id="welcome">
Bienvenidos,</span><br/>

desde hace más de 20 años elaboramos delicias latinoamericanas como empanadas, arepas, tamales, pan de jamón, postres y pasteles. Le ofrecemos arreglos de catering individuales e inolvidables en calidad orgánica gourmet. Varias embajadas latinoamericanas confían una y otra vez en nuestro servicio.
<br/>
Desde diciembre de 2023, ahora también realizamos entregas a domicilios a partir de un valor de pedido de 50 euros más una tarifa plana de desplazamiento de 8 euros. Entrega tres días a la semana (martes, viernes y sábados).</p>
</div>
</div>

<div className="container-fluid" id="page-section">
  <h4 id="recetas">Zutaten</h4>
  <div className="row">
  <div className="col-sm-6">
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Arepas aus Mais</h5>
        <p className="card-text"><small className="text-muted">Masse:</small> Maismehl, Salz, Wasser, Öl</p>
        <a href="#menu" class="btn btn-primary">Vegan, Glutenfrei</a>
      </div>
    </div>
  </div>
  <div className="col-sm-6">
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Arepa aus Dinkel</h5>
        <p className="card-text"><small className="text-muted">Masse:</small> Dinkelmehl, Salz, Wasser, Öl</p>
        <a href="#menu" className="btn btn-primary">Vegan</a>
      </div>
    </div>
  </div>
</div>
<div className="row">
  <div className="col-sm-6">
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Empanadas</h5>
        <p className="card-text"><small className="text-muted">Masse:</small> Mehl, Salz, Wasser, Öl
        <small className="text-muted">  Füllung:</small> Tomaten, Bratgemüse, Champignons, Speisen
        <small className="text-muted">  Auf Wünsch:</small> Chili sin Carne oder Käse
        <small className="text-muted">  Scharfe Söße:</small> Chili, Speisen, Öl</p>
        <a href="#menu" class="btn btn-primary">Vegan/Vegetarisch</a>
      </div>
    </div>
  </div>
  <div className="col-sm-6">
    <div className="card">
      <div className="card-body">
        <h5 className="card-title">Tamales</h5>
        <p className="card-text"><small className="text-muted">Masse:</small> Maismehl, Salz, Wasser, Bananenblättern, Öl
        <small className="text-muted">  Beilagen:</small> Tomaten, Bratgemüse, Oliven, Kapern, Champignons, Speisen</p>
       
        <a href="#menu" className="btn btn-primary">Vegan, Glutenfrei</a>
      </div>
    </div>
  </div>
</div>
  
  </div>
  <div className="container-fluid" id="page-section">
  <div id ="menu" className="card border-warning mb-3" >
  <h4 id="menu">Menü</h4>
  <ul>     
    <li className="list-group-item list-group-item-warning"><div className="row">
       <div className="col-sm-6 d-flex justify-content-start"> 
            <img className="img-fluid img-thumbnail" src={placeholder1} id="menu1"></img>
             </div> 
      <div className="col-sm-6"> <span id="specialidad" className="display-6">Arepa aus Mais / Arepa de mais</span></div><div className="col-sm-5 d-flex justify-content-end"><span id="preis" alt="preis" className="blockquote-footer" >5€</span></div>
    </div></li> 
    <div className="row">
        
     <div className="col-sm-4 d-flex justify-content-start">  
      <div className="order-wrapper  d-flex align-items-stretch">
             <div><button id="order-decrement" onClick={() =>decrementOrder("arepasMais")}>-</button></div> 
             <div id="order"><span>{cart.arepasMais}</span></div>
             <div> <button id="order-increment" onClick={() =>incrementOrder("arepasMais")}>+</button></div> 
           </div>
            </div>
           </div>
    <li className="list-group-item list-group-item-warning"> <div className="row"><div className="col-sm-6 d-flex justify-content-start"> 
            <img className="img-fluid img-thumbnail" src={placeholder1} id="menu2"></img>
             </div> <div className="col-sm-5"> <span id="specialidad" className="display-6">Arepa aus Dinkelmehl / Arepa de espelta</span></div><div className="col-sm-5 d-flex justify-content-end"> <span id="preis" alt="preis" className="blockquote-footer text-wrap">5€</span></div>
     </div></li>
    
    <div className="row">
      
    <div className="col-sm-4 d-flex justify-content-start">  
       <div className="order-wrapper  d-flex align-items-stretch">            
            <div><button id="order-decrement" onClick={() =>decrementOrder("arepasDinkel")}>-</button></div> 
            <div id="order"><span>{cart.arepasDinkel}</span></div>
            <div><button id="order-increment" onClick={() =>incrementOrder("arepasDinkel")}>+</button></div> 
            </div>
            </div>  
            </div>
          
    <li className="list-group-item list-group-item-warning"> <div className="row">
       <div className="col-sm-6 d-flex justify-content-start"> 
            <img className="img-fluid img-thumbnail" src={placeholder2} id="menu3"></img>
             </div> 
      <div className="col-sm-6"><span id="specialidad" className="display-6">Empanadas inkl. scharfer Soße/incl. pikante</span></div><div className="col-sm-5 d-flex justify-content-end"><span id="preis" alt="preis" className="blockquote-footer text-wrap">5€</span></div></div></li>
    <div className="row"> <span id="descripton">(Käse, Gemüse, Chili sin Carne oder VEGAN: Gemüse, Champingnons, Sojafleisch)
(Queso, chili sin carne o VEGANO: verduras, setas, carne de soja)</span></div>
      <div className="row">
     
<div className="col-sm-4 d-flex justify-content-start">   
  <div className="order-wrapper  d-flex align-items-stretch">      
              <div><button id="order-decrement" onClick={() => decrementOrder("empanadas")}>-</button></div>
              <div id="order"> <span>{cart.empanadas}</span></div>
              <div><button id="order-increment" onClick={() =>incrementOrder("empanadas")}>+</button></div>
            </div>
            </div> 
            </div>
               
    <li className="list-group-item list-group-item-warning">  <div className="row"> 
      <div className="col-sm-6 d-flex justify-content-start"> 
            <img className="img-fluid img-thumbnail" src={placeholder2} id="menu4"></img>
             </div> 
       <div className="col-sm-6"><span id="specialidad" class="display-6">Tamales</span></div>  <div className="col-sm-5 d-flex justify-content-end"><span id="preis" alt="preis" className="blockquote-footer text-wrap">12/10 €</span></div></div> </li>
    <div className="row"><span id="descripton">(Masse aus Mais, gekocht in Bananenblättern – gefüllt mit Gemüsen, Oliven, Karpen)
(una mezcla de maíz, cocido en hojas de plátano – relleno de verduras, aceitunas, carpas)</span></div> 
<div className="row">

 
<div className="order-wrapper  d-flex align-items-stretch">
  <div className="row">
   <div className="col-sm-10 d-flex flex-row">
                       <span className="text-wrap">größ: </span>  
            <div>  <button id="order-decrement" onClick={() =>decrementOrder("tamalesGrandes")}>-</button></div>
              <div id="order"><span>{cart.tamalesGrandes}</span></div>
              <div><button id="order-increment" onClick={() =>incrementOrder("tamalesGrandes")}>+</button></div>
            </div>
 </div>
 </div>
 <br/>
 <div className="order-wrapper  d-flex align-items-stretch">
   <div className="row">
  <div className="col-sm-10 d-flex flex-row">       
              <span className="text-wrap">klein: </span>
              <div><button id="order-decrement" onClick={() =>decrementOrder("tamalesChiki")}>-</button></div>
              <div id="order"><span>{cart.tamalesChiki}</span></div>
              <div><button id="order-increment" onClick={() =>incrementOrder("tamalesChiki")}>+</button></div>
            </div>
            </div>
            </div>
 </div> 
    <br/>
    </ul>
    <blockquote><span id="specialidad" class="text-muted font-weight-bold mx-auto">Alle Preise verstehen sich inklusive 19% Mehrwertsteuer.
Todos los precios incluyen el 19% de IVA.<br/>

</span></blockquote>
  
  <a className="btn btn-primary btn-lg" href="#" role="button" onClick={()=>redirectToCheckout()}>Bestellen</a>
  </div>
  </div>
  <div className="container-fluid" id="page-section">
  <h4 id="kontakt" alt="kontakt und Catering">Kontakt</h4>
  <p className="lead"><small className="text-muted">E-Mail:</small> <span className="display-6 border-left" alt="info@empanadasytamales.de">info@empanadasytamales.de</span> <br/>
<small class="text-muted">Tel.:</small><span className="display-6 border-left"> (+49) 176 62 88 53 91 </span>
<br/>Für jeden Rückfragen stehe wir Ihnen jederzeit zur Verfügung. Gerne können wir ein Catering für ihre Verstaltung organisieren.</p>
</div>
<div className="container-fluid" id="page-section">
<h4 id="fronteraLatina" alt="frontera latina">Frontera Latina</h4>
<img className="img-fluid" id="frontera-logo" src="https://www.fronteralatina.de/wp-content/imagenes/2017/11/cropped-Logo11-1920x295.png" alt="frontera latina logo"></img>
  <p className="lead"><small className="text-muted">E-Mail:</small> <span class="display-6 border-left" alt="info@fronteralatina.de">info@fronteralatina.de</span> <br/>
<a href="https://www.fronteralatina.de/">https://www.fronteralatina.de</a>
<br/>

Somos el primer periódico cultural y turístico de habla hispana fundado en Berlín, capital de la República Federal de Alemania. Nuestro medio está dirigido primordialmente a la comunidad latinoamericana residenciada en suelo germano a objeto de estrechar sus lazos y mantenerla informada en torno a la actualidad cultural y turística local, nacional e internacional.</p>

</div>
<div className="container-fluid" id="page-section">
<h4 id="bioVegano" alt="bio vegano">Bio Vegano</h4>
  <p class="lead"><a href="www.biovegano.de">www.biovegano.de</a></p>

</div>
<div className="container-fluid" id="page-section">
<h4 id="lunasol" alt="galeria lunasol">Galeria Lunasol</h4>
<a href="https://lunasol.berlin/wp-content/uploads/2018/06/20180621_200406.jpg"><img class="img-fluid" id="galeria" src="https://lunasol.berlin/wp-content/uploads/2018/06/20180621_200406.jpg" alt="Vicky"></img></a>
  <p class="lead"><small class="text-muted">Anschrift: </small> <span class="display-7 border-left" alt="Schierker Straße 35, 12051 Berlin">Schierker Straße 35, 12051 Berlin</span> <br/>
 
  <small class="text-muted">Tel: </small><span class="display-7 border-left" alt="+49 176 62 88 53 91">+49 176 62 88 53 91</span> <br/>
  
  <small class="text-muted">Email: </small> <span class="display-7 border-left" alt="info@lunasol.berlin">
info@lunasol.berlin</span>

<script src="https://static.elfsight.com/platform/platform.js" async></script>
<div class="elfsight-app-e0bbabc5-b74a-4171-9201-7455fb41284d" data-elfsight-app-lazy></div>

<br/>
  Die Galería Lunasol wird von Vicky Prieto seit nun 15 Jahren in Berlin mit Herz und Seele geführt. Mit ihrem Projekt versucht sie den internationalen Austausch verschiedener Künstler und zeitgenössischer Kunststile zu fördern und ist immer auf der Suche ein Fenster zum internationalen lateinamerikanischen Raum zu öffnen, indem sie internationale Künstler einlädt, die mit ihrer Kreativität die Galerie unterstützen und weitere Türen öffnen. Außerdem ist die Galerie ein Taller, indem verschiedene internationale Künstler mit Ihrer Kreativität die Ausstellungsräume unterstützen und für einen multikulturellen künstlerischen Austausch sorgen.</p>

</div>

       <div className="visitCard container-fluid" id="page-section">
       <div className="card mb-3" id="card-container">
       <img className="card-img-top" src={empayLogo} alt="visit card"/>
       <div className="card-body">
       <h5 className="card-title">Impressum</h5>
       <div className="row">
        <div className="col-12 col-md-6 mb-3">
        
         <p className="card-text text-wrap"><small className="text-muted">Angaben gemäß § 5 TMG:</small><br/>
Empanadas y Tamales</p>
</div>
<div className="col-12 col-md-6 mb-3">
         <p className="card-text text-wrap"><small className="text-muted">Vertreten durch:</small><br/>Vicky Prieto<br/>
Schierker Straße 35<br/>
12051 Berlin<br/>

Ust.-Id: DE265236090</p>
</div>
</div>
       </div>
     </div>
    </div>

</div>
</div>
    );
   

  }

export default App;
